import { render, staticRenderFns } from "./RadioGroup.component.vue?vue&type=template&id=394e228a&scoped=true&"
import script from "./RadioGroup.component.vue?vue&type=script&lang=js&"
export * from "./RadioGroup.component.vue?vue&type=script&lang=js&"
import style0 from "./RadioGroup.component.vue?vue&type=style&index=0&id=394e228a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394e228a",
  null
  
)

export default component.exports